import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { useQuery } from '@tanstack/react-query';
import { notificationsConfig } from '../../config/constants';
import { getAlertsQuery } from './alert.status.query';
import { ALERT_ENUM } from './alert.types';
const getAlertStatus = async () => {
    const final = {
        [ALERT_ENUM.HIGH]: 0,
        [ALERT_ENUM.MEDIUM]: 0,
        [ALERT_ENUM.LOW]: 0,
    };
    const alerts = await getAlertsQuery();
    alerts.forEach((alert) => {
        if (ALERT_ENUM.HIGH === alert.severity) {
            final[ALERT_ENUM.HIGH] += alert.totalCount;
        }
        if (ALERT_ENUM.MEDIUM === alert.severity) {
            final[ALERT_ENUM.MEDIUM] += alert.totalCount;
        }
        if (ALERT_ENUM.LOW === alert.severity || ALERT_ENUM.OTHERS === alert.severity) {
            final[ALERT_ENUM.LOW] += alert.totalCount;
        }
    });
    return final;
};
export const useAlertQuery = () => {
    const dispatch = useDispatch();
    return useQuery({
        queryFn: getAlertStatus,
        queryKey: ['alerts'],
        onError: () => dispatch(error({
            translationKey: 'widget:widget:cant_load_alerts',
            ...notificationsConfig.defaultConf,
        })),
    });
};
//# sourceMappingURL=useAlertQuery.js.map